module.exports = __webpack_public_path__ + "static/img/banner.1dd62139.png";